export default __webpack_public_path__ + "static/media/bike_card_5.e77faa29.png";